'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var responseState = {
    SUCCESS: 'success',
    ERROR: 'error'
};

exports.responseState = responseState;